import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
export var useApplyChangesBasedOnSearchParam = function () {
    var _a = React.useState(false), hasCustomParams = _a[0], setHasCustomParams = _a[1];
    var _b = useFormContext(), setValue = _b.setValue, isDirty = _b.formState.isDirty, watch = _b.watch;
    var _c = useSearchParams(), searchParams = _c[0], setSearchParams = _c[1];
    var changeSearchParam = searchParams.get('_change');
    watch(function () {
        // whenever the user changes a field, we remove the alert
        setHasCustomParams(false);
    });
    React.useEffect(function () {
        if (!changeSearchParam) {
            return;
        }
        try {
            var changedFields = JSON.parse(changeSearchParam);
            Object.entries(changedFields).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                setValue(key, value, { shouldDirty: true });
            });
            setHasCustomParams(true);
            setSearchParams();
        }
        catch (e) {
            // invalid JSON, do nothing
        }
    }, [changeSearchParam, setSearchParams, setValue]);
    return isDirty && hasCustomParams;
};
